import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-user-edit-delete-button-renderer',
  templateUrl: './user-edit-delete-button-renderer.component.html',
  styleUrls: ['./user-edit-delete-button-renderer.component.scss']
})
export class UserEditDeleteButtonRendererComponent implements ICellRendererAngularComp {

  fromComponent = '';

  sectionName = '';

  params: any;

  idString = '';

  user_mgmt_enabled: boolean;

  user_tiers_enabled: boolean;

  tiersArr: Array<string>;

  isUserWebhookPresent = false;

  isNewRecord = false;

  approval_flow_enabled_for_app = false;

  constructor() { }

  agInit(params: any): void {
    this.params = params;
    this.fromComponent = this.params.context.componentParent.fromComponent;
    this.sectionName = this.params.context.componentParent.sectionName;
    this.user_mgmt_enabled = this.params.context.componentParent.configOptionsOnChanges?.user_mgmt_enabled;
    this.user_tiers_enabled = this.params.context.componentParent.configOptionsOnChanges?.user_tiers_enabled;
    this.tiersArr = this.params.context.componentParent.tiersArr;
    this.isUserWebhookPresent = this.params.context.componentParent?.isUserWebhookPresent;
    // console.log(this.params);
    this.isNewRecord = this.params?.data.isNew ? true : false;
    this.approval_flow_enabled_for_app = this.params.context.componentParent?.appDetailsData?.approval_flow_enabled ? true : false;
  }

  createIdString() {
    if (this.fromComponent && this.sectionName) {
      return this.fromComponent + '-' + this.sectionName + '-configSelect'
    } else {
      return 'configBtn';
    }
  }

  handleActionClickEvent(event: string) {
    // this.managementService.vendorEditClickSub.next(this.params);
    this.params.context.componentParent.handleClick(event, this.params.data);
  }

  refresh(): boolean {
    return false;
  }

}
